import FileUploadControl from './FileUploadControl';
export default FileUploadControl;
